const mediaQuery = window.matchMedia('(min-width: 1025px)');
let swiper;

function initTargetSelector() {
  if (mediaQuery.matches) {
    handleDesktop();
  } else {
    handleMobile();
  }
}

function handleDesktop() {
  if (swiper) {
    swiper.destroy(true, true);
  }
  const ailments = document.querySelectorAll('[data-ailment-id]');

  ailments.forEach(ailment => {
    ailment.addEventListener('mouseenter', e => {
      const ailmentId = e.target.dataset.ailmentId;
      document.querySelector(`li a[data-touchpoint-id="${ailmentId}"]`).classList.add('target_area__touchpoint-link--active');
      document.querySelector(`div[data-touchpoint-id="${ailmentId}"]`).classList.remove('hidden');
      document.querySelector(`div[data-touchpoint-id="default"]`).classList.add('hidden');
    });
    ailment.addEventListener('mouseleave', e => {
      const ailmentId = e.target.dataset.ailmentId;
      document.querySelector(`li a[data-touchpoint-id="${ailmentId}"]`).classList.remove('target_area__touchpoint-link--active');
      document.querySelector(`div[data-touchpoint-id="${ailmentId}"]`).classList.add('hidden');
      document.querySelector(`div[data-touchpoint-id="default"]`).classList.remove('hidden');
    });
  });

  const touchpoints = document.querySelectorAll('.target-area__touchpoint-link');
  touchpoints.forEach(touchpoint => {
    touchpoint.addEventListener('mouseenter', e=> {
      const ailmentId = e.target.dataset.touchpointId;
      document.querySelector(`div[data-touchpoint-id="${ailmentId}"]`).classList.remove('hidden');
      document.querySelector(`div[data-touchpoint-id="default"]`).classList.add('hidden');
    })
    touchpoint.addEventListener('mouseleave', e=> {
      const ailmentId = e.target.dataset.touchpointId;
      document.querySelector(`div[data-touchpoint-id="${ailmentId}"]`).classList.add('hidden');
      document.querySelector(`div[data-touchpoint-id="default"]`).classList.remove('hidden');
    })
  })
}

function handleMobile() {
  swiper = new Swiper('.swiper', {
    init: false,
    speed: 400,
    spaceBetween: 20,
    slidesPerView: 'auto',
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: true
    },
    loop: true
  });
  swiper.on('init', function() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    if (activeSlide) {
      const activeIndex = activeSlide.dataset.swiperSlideIndex;
      document.querySelector(`.target-area__wrapper [data-touchpoint-id="${activeIndex}"]`).classList.add('target_area__touchpoint-link--active');
    }
  });
  swiper.on('slideChangeTransitionEnd', function() {
    const activeSlide = document.querySelector('.swiper-slide-active');
    if (activeSlide) {
      const activeIndex = activeSlide.dataset.swiperSlideIndex;
      document.querySelectorAll('[data-touchpoint-id]').forEach(touchPoint => {
        touchPoint.classList.remove('target_area__touchpoint-link--active');
      });
      document.querySelector(`.target-area__wrapper [data-touchpoint-id="${activeIndex}"]`).classList.add('target_area__touchpoint-link--active');
    }
  });
  swiper.init();
  console.log(swiper);
}

mediaQuery.addEventListener('change', initTargetSelector);
window.onload = initTargetSelector();
